import React, { PureComponent } from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import ImageElement from './ImageElement/ImageElement';
import ParagraphElement from './ParagraphElement/ParagraphElement';
import ButtonElement from './ButtonElement/ButtonElement';
import SpacerElement from './SpacerElement/SpacerElement';
import SocialElement from './SocialElement/SocialElement';
import SurveyElement from './SurveyElement/SurveyElement';
import VideoElement from './VideoElement/VideoElement';
import CKEditorElement from './ParagraphElement/CKEditorElement';
import { elementContentType } from '../../../../../../../types';
import elementTypes from '../../../../../../../constants/elementTypes';

class Element extends PureComponent {
    render() {
        const {
            type,
            blockIndex,
            columnIdx,
            elmIdx,
            content,
            width,
            imageHeight,
            elementIsSelected,
            multipleElementsSelected,
            flags,
        } = this.props;

        switch (type) {
            case elementTypes.IMAGE:
                return (
                    <ImageElement
                        content={content}
                        width={width}
                        imageHeight={imageHeight}
                        elementIsSelected={elementIsSelected}
                        elmIdx={elmIdx}
                        blockIndex={blockIndex}
                        columnIdx={columnIdx}
                    />
                );
            case elementTypes.TABLE:
            case elementTypes.PARAGRAPH:
                // paragraph is the only element that dispatches actions due to wisywyg editor hence needs a reference to element indices
                if (flags.pik1913TextEditorModule) {
                    return (
                        <CKEditorElement
                            blockIndex={blockIndex}
                            columnIdx={columnIdx}
                            elementType={type}
                            elmIdx={elmIdx}
                            content={content}
                            width={width}
                            elementIsSelected={elementIsSelected}
                            multipleElementsSelected={multipleElementsSelected}
                        />
                    );
                }
                return (
                    <ParagraphElement
                        blockIndex={blockIndex}
                        columnIdx={columnIdx}
                        elmIdx={elmIdx}
                        content={content}
                        width={width}
                        elementIsSelected={elementIsSelected}
                        multipleElementsSelected={multipleElementsSelected}
                    />
                );
            case elementTypes.BUTTON:
                return <ButtonElement content={content} />;
            case elementTypes.SPACER:
                return <SpacerElement content={content} />;
            case elementTypes.SOCIAL:
                return <SocialElement content={content} />;
            case elementTypes.SURVEY:
                return (
                    <SurveyElement
                        content={content}
                        blockIndex={blockIndex}
                        columnIdx={columnIdx}
                        elmIdx={elmIdx}
                        type={type}
                    />
                );
            case 'VIDEO':
                return <VideoElement content={content} width={width} imageHeight={imageHeight} />;
            default:
                return null;
        }
    }
}

Element.propTypes = {
    type: PropTypes.string.isRequired,
    blockIndex: PropTypes.string.isRequired,
    columnIdx: PropTypes.string.isRequired,
    elmIdx: PropTypes.string.isRequired,
    content: elementContentType.isRequired,
    width: PropTypes.number.isRequired,
    imageHeight: PropTypes.number,
    elementIsSelected: PropTypes.bool.isRequired,
    multipleElementsSelected: PropTypes.bool.isRequired,
    flags: PropTypes.shape({
        pik1913TextEditorModule: PropTypes.bool.isRequired,
    }).isRequired,
};

Element.defaultProps = {
    imageHeight: null,
};

export default withLDConsumer()(Element);
